import React from 'react';
import {
  Button,
  Modal,
  message
} from 'antd';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined
} from '@ant-design/icons';

import './style';
import { toThousands } from '../../utils/Numeric';
import { Loadding } from '../../components';

export default React.forwardRef((props, ref) => {
  const { data, readOnly, reload, deliveryId, editPallet, deletePallet, deletePackage } = props;

  const pallets = data.pallets || [];
  const packages = data.packages || [];
  const total = {
    weight: 0,
    count: 0,
    amount: 0
  };

  (packages || []).forEach((item, index) => {
    total.weight += (item.weight || 0);
    total.count += (item.carton_count * item.count_per_carton);
    total.amount += 0;
  });

  const cartons = (packages || []).filter(x => x.pallet_id === -1);
  let total_cartons_weights = 0;
  let total_cartons_count = 0;
  cartons.forEach((item, index) => {
    total_cartons_weights += (item.weight || 0);
    total_cartons_count += (item.carton_count || 0);
  });

  const deletePalletConfirm = (i, id) => {
    Modal.confirm({
      title: '删除托盘',
      icon: <ExclamationCircleOutlined />,
      content: <strong>确定删除第{i}托盘吗?</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {

        try {
          const key = 'delete_delivery_plan';
          console.log('onDeleteDeliveryPlan:', id);
          message.loading({ content: '正在删除散箱数据...', key });
          deletePallet && deletePallet(deliveryId, id).then(() => {
            reload && reload().then(() => {
              message.success({ content: `删除散箱数据成功`, key, duration: 2 });
            });
          });

        } catch (errInfo) {
          console.log('Error:', errInfo);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  const deletePackageConfirm = (i, id) => {
    Modal.confirm({
      title: '删除产品',
      icon: <ExclamationCircleOutlined />,
      content: <strong>确定选中的【{i}】产品吗?</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        try {
          const key = 'delete_delivery_plan';
          console.log('onDeleteDeliveryPlan:', id);
          message.loading({ content: '正在删除散箱数据...', key });
          deletePackage && deletePackage(deliveryId, id).then(() => {
            reload && reload().then(() => {
              message.success({ content: `删除散箱数据成功`, key, duration: 2 });
            });
          });

        } catch (errInfo) {
          console.log('Error:', errInfo);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }
  return (
    <div>
      {
        (!packages || !pallets) && <Loadding />
      }
      {
        (packages && pallets) && <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            客户名称: <strong>[{data.buyer_name_nick}]{data.buyer_name}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          发货类型: <strong>{data.delivery_type_name}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          箱型: <strong>{data.container_name}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          发货备注: <strong>{data.delivery_remark}</strong>&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            {!readOnly && <Button size="small" onClick={() => editPallet(-1, 0, data)} type="primary" icon={<PlusOutlined />}>添加新托盘</Button>}
          </div>
        </div>
      }
      {
        (packages && pallets) && <table style={{ border: '2px solid #f0f0f0' }} className="table">
          <thead style={{ backgroundColor: '#fff' }}>
            <tr>
              <td className="th" rowSpan="2" width="380px" >产品号</td>
              <td className="th" rowspan="2" >供应商</td>
              <td className="th" rowspan="2" >P.O</td>
              {/* <td className="th" rowspan="2" >订单号</td> */}
              <td className="th" rowspan="2" >发货日期</td>
              <td className="th" rowspan="2" >箱数</td>
              <td className="th2" colspan="2">数量(件)</td>
              <td className="th" rowSpan="2">重量<br />(千克)</td>
              <td className="th" rowSpan="2">总重量<br />(千克)</td>
              {!readOnly && <td align="center" className="th" rowSpan="2">#</td>}
            </tr>
            <tr>
              <td align="center" style={{ paddingTop: 0, paddingBottom: 0 }} className="th">件数/箱</td>
              <td align="center" style={{ paddingTop: 0, paddingBottom: 0 }} className="th">总件数</td>
            </tr>
          </thead>
          <tbody>
            {
              pallets.map((item, pindex) => {
                const palletPackage = packages.filter(x => x.pallet_id === item.id);
                let total_weights = 0;
                for (let i = 0; i < palletPackage.length; i++) {
                  total_weights += (palletPackage[i].weight || 0);
                }
                return [
                  <tr>
                    <td style={{ backgroundColor: '#fff' }} className="td" colspan={10}>
                      <div style={{ fontSize: "1.1rem", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>第{pindex + 1}托盘</span>
                        {!readOnly && <span>
                          <Button size="small" onClick={() => deletePalletConfirm(pindex + 1, item.id)} danger icon={<DeleteOutlined />}>删除此托盘</Button>
                          &nbsp;&nbsp;
                          <Button type="primary" size="small" onClick={() => editPallet(pindex + 1, item.id, data)} icon={<PlusOutlined />}>添加散箱</Button>
                        </span>}
                      </div>
                    </td>
                  </tr>,
                  palletPackage.map((carton, index) => {
                    return <tr>
                      <td className="td">
                        {carton.goods_spec_name}&nbsp;
                        {carton.size}&nbsp;&nbsp;
                        {carton.goods_name}
                      </td>
                      <td className="td" align="center">
                        {carton.supplier_name}
                      </td>
                      <td className="td" align="center" >
                        {carton.po_code}
                      </td>
                      <td className="td" align="center" >
                        {/* {carton.no} */}
                        {carton.package_delivery_date}
                      </td>
                      <td align="right" className="td">{toThousands(carton.carton_count)}</td>
                      <td align="right" className="td">{toThousands(carton.count_per_carton)}</td>
                      <td align="right" className="td">{toThousands(carton.carton_count * carton.count_per_carton)}</td>
                      <td align="right" className="td">{toThousands(carton.weight.toFixed(2))}</td>
                      {
                        index === 0 && <td align="right" className="td" rowspan={palletPackage.length}>{toThousands(total_weights.toFixed(2))}</td>
                      }
                      {!readOnly && <td className="td">
                        <DeleteOutlined onClick={() => deletePackageConfirm(carton.goods_spec_name, carton.id)} style={{ color: 'red' }} />
                      </td>
                      }
                    </tr>
                  })
                ]
              })
            }
            {
              cartons.length > 0 && <tr>
                <td style={{ backgroundColor: '#fff' }} className="td" colspan={10}>
                  <div style={{ fontSize: "1.1rem", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <strong>散箱</strong>
                    {!readOnly && <Button size="small" type="primary" onClick={() => editPallet(-1, -1, data)} icon={<PlusOutlined />}>添加散箱</Button>}
                  </div>
                </td>
              </tr>
            }
            {
              cartons.map((item, index) => {
                return <tr>
                  <td className="td">
                    {item.goods_spec_name}&nbsp;
                    {item.size}&nbsp;&nbsp;
                    {item.goods_name}
                  </td>
                  <td className="td" align="center">
                    {item.supplier_name}
                  </td>
                  <td className="td" align="center" >
                    {item.po_code}
                  </td>
                  <td className="td" align="center" >
                    {/* {item.no} */}
                    {item.package_delivery_date}
                  </td>
                  <td align="right" className="td">{toThousands(item.count / item.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(item.count_per_carton)}</td>
                  <td align="right" className="td">{toThousands(item.count)}</td>
                  <td align="right" className="td">{toThousands(item.weight.toFixed(2))}</td>
                  {
                    index === 0 && <td align="right" className="td" rowspan={packages.filter(x => x.pallet_id === item.id).length}>
                      {
                        toThousands(total_cartons_weights.toFixed(2))
                      }
                    </td>
                  }
                  {!readOnly && <td className="td">
                    <DeleteOutlined onClick={() => deletePackageConfirm(item.goods_spec_name, item.id)} style={{ color: 'red' }} />
                  </td>
                  }
                </tr>
              })
            }
          </tbody>
          <tfoot style={{ backgroundColor: '#fff' }}>
            <td className="td" colSpan={5}>
              <div style={{ fontSize: '1.1rem', display: 'flex', justifyContent: 'space-between' }}>
                <strong></strong>
                合计：{pallets.length}托   +  {total_cartons_count}散箱
              </div>
            </td>
            <td className="td" colSpan="2">
              <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                总数量:  {toThousands(total.count)}
              </div>
            </td>
            <td className="td" colSpan="2">
              <div style={{ textAlign: 'right', fontSize: '1.1rem' }}>
                总重量:  {toThousands(total.weight.toFixed(2))}
              </div>
            </td>
          </tfoot>
        </table>
      }
    </div>
  );
});